import React, { memo } from 'react';
import { cn } from '@/shared/utils/cn';

export interface TextListIndicatorProps {
  /** Color del indicador (valor CSS) */
  color: string;
  /** Tamaño del indicador en píxeles */
  size: number;
  /** Clase CSS adicional */
  className?: string;
}

/**
 * Indicador circular de color
 * Átomo que representa un punto de color para identificar categorías
 */
export const TextListIndicator = memo(({ color, size, className }: TextListIndicatorProps) => {
  const indicatorStyle: React.CSSProperties = {
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
    backgroundColor: color,
    flexShrink: 0,
  };

  return (
    <div
      className={cn('ui-flex-shrink-0', className)}
      style={indicatorStyle}
      role="presentation"
      aria-hidden="true"
    />
  );
});

TextListIndicator.displayName = 'TextListIndicator';
